import { indexedDB } from '@th-common/db';
import { TLogLevelsIndexedDB } from '@th-common/enums/indexed-db/log-level';
import { v4 as uuid4 } from 'uuid';

import { DateTimeUtils } from '../dateTime';

/**
 * This function adds a log entry to the IndexedDB logs store. (Not use in the component)
 */
export const addLog = async (logLevel: TLogLevelsIndexedDB, log: string, state?: Record<string, any>): Promise<void> => {
  const date = DateTimeUtils.timestampDisplay(new Date().toISOString());
  const userName = state?.userProfile?.me?.userName || 'Unknown User';
  const userId = state?.userProfile?.me?.id || null;

  await indexedDB.logs.add({
    id: uuid4(),
    logLevel,
    log,
    userId,
    userName,
    date,
  });
};
